import React from 'react';
import AlbumTitle from './AlbumTitle';
import GenreList from '../../common/GenreList';

// Helper function to format the date
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
  });
};

const AlbumDetails = ({ album, accentColor, wikiContent }) => {
  console.log('AlbumDetails received wikiContent:', wikiContent);

  return (
    <div className="flex flex-col md:h-full xl:w-1/2 md:w-2/3 w-full z-20 md:overflow-auto bg-amber-50">
      <div style={{ backgroundColor: accentColor }}>
        <AlbumTitle
          title={album.name}
          subtitle={album.artist}
          releaseDate={album.releaseDate}
          accentColor={accentColor}
        />
      </div>

      <div className="flex flex-1 flex-col justify-between gap-8 py-8 sm:px-8 px-4 pb-12">
        <ul className="flex flex-row flex-wrap justify-center items-center gap-2 text-xl uppercase">
          <li
            className="flex w-fit px-3 py-1 rounded-full text-amber-50 text-base pangram-sans-bold"
            style={{ backgroundColor: accentColor }}
          >
            {formatDate(album.releaseDate)}
          </li>
          <GenreList genres={album.genres} accentColor={accentColor} />
        </ul>

        <div 
          className="whitespace-pre-line text-justify select-text sm:text-lg text-base"
          dangerouslySetInnerHTML={{ __html: wikiContent }}
        />

        <div>
          <a
            className="cursor-pointer"
            href={album.wikipediaUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            ➞ Wikipedia
          </a>
        </div>
      </div>
    </div>
  );
};

export default AlbumDetails;